import React, { FC } from 'react';
import { AdditionalType } from '../../../model/interfaces';
import { FinishedTournamentInfo } from './finishedTournamentInfo/finishedTournamentInfo';
import FinishedTournamentWinner from './finishedTournamentWinner/finishedTournamentWinner';
import { FinishedTournamentScheme } from './finishedTournamentScheme/finishedTournamentScheme';

type PropsType = {
  data: AdditionalType;
};

export type Winners = Array<{ [key: string]: string | undefined }>;

export const FinishedTournamentAdditional: FC<PropsType> = ({
  data,
}: PropsType) => {
  const info = {
    directorName: data.directorName,
    directorId: data.directorId,
    startTime: data.startTime,
    pairing: data.pairing,
    timeControl: data.timeControl,
    entryFee: data.entryFee,
    description: data.description,
    extraBonus: data.extraBonus,
  };

  const winners = [
    {
      amt: data.firstPrizeAmt,
      name: data.firstPrizeUsr,
    },
    {
      amt: data.secondPrizeAmt,
      name: data.secondPrizeUsr,
    },
    {
      amt: data.thirdPrizeAmt,
      name: data.thirdPrizeUsr,
    },
    {
      amt: data.fourthPrizeAmt,
      name: data.fourthPrizeUsr,
    },
  ];
  const idTourney = data.tourneyID;

  return (
    <div className="finished-additional">
      <FinishedTournamentInfo info={info} />
      <FinishedTournamentWinner winners={winners} />
      <FinishedTournamentScheme idTourney={idTourney} />
    </div>
  );
};
